import React from 'react';

const Line = ({ color = '#ffffff' }) => {
    return (
        <svg
            width='51'
            height='47'
            viewBox='0 0 51 47'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='1'
                d='M0.208887 44.3205C0.100161 44.5743 0.217792 44.8682 0.471626 44.977L4.60811 46.7488C4.86195 46.8576 5.15586 46.7399 5.26459 46.4861C5.37332 46.2323 5.25569 45.9384 5.00186 45.8296L1.32498 44.2546L2.89997 40.5778C3.0087 40.3239 2.89107 40.03 2.63724 39.9213C2.3834 39.8125 2.08948 39.9302 1.98075 40.184L0.208887 44.3205ZM49.1871 0.0984211C44.432 11.6318 39.4169 19.7366 32.0362 26.3935C24.6468 33.0581 14.8528 38.302 0.482719 44.0532L0.854279 44.9816C15.26 39.2162 25.1847 33.9196 32.7059 27.1361C40.2358 20.3447 45.3232 12.0936 50.1116 0.479587L49.1871 0.0984211Z'
                fill={color}
            />
        </svg>
    );
};

export default Line;
